const Math = require("mathjs");

const math = Math.create(Math.all,{
    number: 'BigNumber',
    precision: 64
});

//
// math.config({
//     number: 'BigNumber',      // Default type of number:
//                               // 'number' (default), 'BigNumber', or 'Fraction'
//     precision: 64             // Number of significant digits for BigNumbers
// });

export default math;
